import React from 'react';
import "./Contact_support.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faEnvelope, faGlobe, faPhone } from '@fortawesome/free-solid-svg-icons';

function Contact_support() {
  return (
    <div className="contact-support">
      <div className="container">
    

      <p class="section_heading text-start">Contact support</p>
      <div className="contact-item">
        <FontAwesomeIcon icon={faMapMarkerAlt} className="icon" />
        <p>
          2nd floor, Office No 3, Opp. High-Class Soc., M.No. 734, <br />
          Near Suryadutta College, Bavdhan Khurd, Pune 411021.
        </p>
      </div>

      <div className="contact-item">
        <FontAwesomeIcon icon={faEnvelope} className="icon" />
        <p>
          <a href="mailto:info@profcymafinance.com">info@profcymafinance.com</a>
        </p>
      </div>

      <div className="contact-item">
        <FontAwesomeIcon icon={faGlobe} className="icon" />
        <p>
          <a href="https://www.profcymafinance.com" target="_blank" rel="noopener noreferrer">
            www.profcymafinance.com
          </a>
        </p>
      </div>

      <div className="contact-item">
        <FontAwesomeIcon icon={faPhone} className="icon" />
        <p>
          <a href="tel:18002678961">1800-267-8961</a> / <a href="tel:+919607755557">+91 96077 55557</a>
        </p>
      </div>
      </div>
    </div>
  );
}

export default Contact_support;
